import https, { getApiConfig } from '../../utils/request'
import { RequestParams, ContentType, Method } from 'axios-mapper'
// 计划备货接口 平台接口
/** 平台-查看备货计划列表 */
export const GetPlanlist = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/plan-list`, Method.GET, data, ContentType.form)
}
/** 平台-查看计划行变动日志*/
export const GetPlanLog = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/log`, Method.GET, data, ContentType.form)
}
/**平台-查看仓库列表 */
export const WarehouseList = (platId) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/warehouse-list?plat_id=${platId}`, Method.GET)
}
/**平台-查看仓库列表 */
export const ShippingType = (platId) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/shipping-type?plat_id=${platId}`, Method.GET)
}
/**平台-查看品类 */
export const GetCategories = (platId) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/categories?plat_id=${platId}`, Method.GET)
}
/**平台-查看备货计划上传进度 */
export const LookPlanCheck = (data:RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/plan-check?plan_id=${data.planId}&plat_id=${data.platId}`, Method.GET)
}



/** 平台-删除计划备货*/
export const DeletePlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/delete-plan`, Method.POST, data)
}

/** 平台-创建/编辑备货计划  传plan_id表示编辑,反之表示创建*/
export const AddRestockPlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/save-plan`, Method.POST, data)
}
/** 平台-备货计划邀请商家*/
export const InviteSeller = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/invite-seller`, Method.POST, data)
}
/** 平台-修改备货数量*/
export const ProposalQuantity = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/proposal-quantity`, Method.POST, data)
}
/** 平台-确定最终备货数量*/
export const ConfirmQuantity = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/quantity`, Method.POST, data)
}
/** 平台-计划行锁定*/
export const LockStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/lock-status`, Method.POST, data)
}
/** 平台-备货计划添加备注*/
export const AddRemark = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/add-remark`, Method.POST, data)
}
/** 平台-备货计划行审核*/
export const ChangeStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/change-status`, Method.POST, data)
}
/**平台-查看计划化详情 传plan_id则查询该id的详情,否则查询列表 */
export const GetPlanlTable = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/plan-detail`, Method.POST, data)
}
/**平台-查看计划行统计信息 type为1时查询创建和已邀请的统计,为2时查询已审核和已关闭的统计 */
export const GetPlanlCount = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/plan-count`, Method.POST, data)
}
/**平台-关闭备货计划 */
export const ClosePlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/close-plan`, Method.POST, data)
}
/**平台-导出数据 */
export const ExportData = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/export-data`, Method.POST, data)
}



// 商家端接口
/** 商家-查看备货计划列表*/
export const GetRestockList = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/plan-list`, Method.GET, data, ContentType.form)
}
/**商家-查看备货单列表 */
export const GetSellerStorageList = (data: RequestParams) => {
    const api_config = getApiConfig()
      const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/storage-list`, Method.GET, data, ContentType.form)
}
/**商家-查看仓库列表 */
export const GetWarehouseList = (platId) => {
    const api_config = getApiConfig()
    const path = Number(platId) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/warehouse-list?plat_id=${platId}`, Method.GET)
}
/**商家-查看发货方式列表 */
export const GetShippingType = (platId) => {
    const api_config = getApiConfig()
    const path = Number(platId) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/shipping-type?plat_id=${platId}`, Method.GET)
}
/**商家-查看品类 */
export const GetSellerCategories = (platId) => {
    const api_config = getApiConfig()
    const path = Number(platId) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/categories?plat_id=${platId}`, Method.GET)
}
/**商家-查看备货单列表Lite */
export const GetLiteStorageList = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.liteSellerUrl).request(`/stock-items/applications`, Method.GET, data, ContentType.form)
}



/**商家-备货计划审核 */
export const PlanChangeStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/change-status`, Method.POST, data)
}
/**商家-卖家添加备货单 */
export const AddStorage = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/add-storage`, Method.POST, data)
}
/**商家-卖家添加备货计划 */
export const SellerAddRestockPlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/add-plan`, Method.POST, data)
}
/**商家-确定可备货数量 */
export const SellerConfirmQuantity = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/quantity`, Method.POST, data)
}
/**商家-删除商家添加的计划行 */
export const SellerDeleteRows = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/delete-rows`, Method.POST, data)
}
/**商家-查看计划行明细 */
export const GetPlanDetail = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/plan-detail`, Method.POST, data)
}
/**商家-查看计划统计信息 */
export const GetSellerPlanCount = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/plan-count`, Method.POST, data)
}
/**商家-卖家查看可选FBK商品 */
export const GetFbkGoods = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/fbk-goods`, Method.POST, data)
}
/**商家-导出数据 */
export const sellerExportData = (data: RequestParams) => {
    const api_config = getApiConfig()
    const path = Number(data.plat_id) === 1 ? '/apiseller' : '/lite'
    return https(api_config.userUrl).request(`${path}/v1/seller/${api_config.siteCode}/export-data`, Method.POST, data)
}


